module.exports = __webpack_public_path__ + "static/bfp_slide_group-2f18644206a1839c9e636d266d8cff48.jpg";